export default __webpack_public_path__ + "static/media/pink.43db0d26.webp";